import React from 'react';
import { renderCognitoForm } from '../utility.js';

class CognitoForm extends React.Component {
  componentDidMount(){
    renderCognitoForm(String(this.props.id));
    
    // Poll for form to appear
    let attempts = 0;
    const checkForForm = () => {
      attempts++;
      
      // Look for the Cognito form element
      const form = document.querySelector('.cog-form.cog-' + this.props.id);
      
      if (form && form.tagName === 'FORM' && !form._gtmTracked) {
        form._gtmTracked = true;
        
        // Find the submit button
        const submitButton = form.querySelector('button[type="submit"], .cog-button__text');
        
        if (submitButton) {
          submitButton.addEventListener('click', (e) => {
            // Small delay to ensure form validation passes
            setTimeout(() => {
              if (window.dataLayer) {
                window.dataLayer.push({
                  event: 'cognito_form_submit',
                  form_id: this.props.id,
                  form_name: this.props.footer_form_name || this.props.formName || 'Cognito Form',
                  custom_tag: this.props.footer_form_custom_tag || this.props.customTag,
                  timestamp: new Date().toISOString()
                });
              }
            }, 100);
          });
        }
      } else if (attempts < 20) {
        setTimeout(checkForForm, 300);
      }
    };
    
    setTimeout(checkForForm, 500);
  }
  
  componentWillUnmount() {
    // Cleanup if needed
  }
  
  render() {
    return (
      <div className={`cognito cognitoForm`}></div>
    );
  }
}

export default CognitoForm;